import { inject, bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import { CookieHelper } from '../../services/cookieHelper';



@inject(AuthService, Router, UserMessageService, CookieHelper)

export class Login {
   
    constructor(authService, router, userMessageService, CookieHelper) {

        this.authService = authService;
        this.router = router;

        this.userMessageService = userMessageService;

        this.recover_password = false;
        this.keep_me_loggedin = false;
        this.cookie = CookieHelper;

    }

    activate(model) {
        this.email = '';
        this.password = '';
        this.password1 = '';
        this.password2 = '';
        this.confirmToken = model.confirm_token;
        this.resetToken = model.reset_token;
        this.redirectUrl = model.url;

        if(model.sso_token){
            this.login_SSO(model.sso_token,this.redirectUrl)
        }

        if(localStorage['magnfi_username'])
            this.email = localStorage['magnfi_username'];
        this.init_keep_me_loggedin();
        console.log("COOKIES:::" + this.cookie.setCookie());

        this.isSSOpage = location.href.includes('sso_token=');

        // const style = document.createElement('style');
        // style.innerHTML = 'footer { display: none; }';
        // document.head.appendChild(style);

    }

    attached(){
    }
    init_keep_me_loggedin(){
        this.email  = this.cookie.getCookie('un') != '' ? this.cookie.getCookie('un') : '';
        this.password = this.cookie.getCookie('ps')!= '' ? this.cookie.getCookie('ps') : '';
        this.keep_me_loggedin = this.cookie.getCookie('kml') == 1 ? true : false;
        if(this.keep_me_loggedin && this.email != '' && this.password != ''){
            console.log('KML:: Logging');
            this.authService.login(this.email, this.password, this.confirmToken, this.redirectUrl);
        } else {
            console.log('KML:: Not Logging');
        }
    }
    
    check_loggedin(){
        var kml = this.cookie.getCookie('kml');
        if(kml == 1){
            console.log('Keep me logged in1 ' + kml);
            this.cookie.setCookie('kml', 0, 30);
            this.keep_me_loggedin = false;
        } else {
            console.log('Keep me logged in0 ' + kml);
            this.cookie.setCookie('kml', 1, 30);
            this.keep_me_loggedin = true;
            
        }
        
    }

    login() {
        //Cleaning the storage items for regular users that have vendasta account
        localStorage.setItem('tp_nav_url', '');
        localStorage.setItem('tp_app_id', '');
        localStorage.setItem('tp_account_id', '');
        localStorage.setItem('tp_product_id', '');
         //Cleaning the storage items for regular users that have vendasta account
        if(this.validateLogin()) {
            this.authService.login(this.email, this.password, this.confirmToken, this.redirectUrl);
        }
    }

    login_SSO(token) {
        //Cleaning the storage items for regular users that have vendasta account
        localStorage.setItem('tp_nav_url', '');
        localStorage.setItem('tp_app_id', '');
        localStorage.setItem('tp_account_id', '');
        localStorage.setItem('tp_product_id', '');
         //Cleaning the storage items for regular users that have vendasta account
            this.authService.loginSSO(token, this.redirectUrl);
    }

    recoverPassword() {
        if(this.validateRecoverPassword()) {
            this.authService.sendPasswordReset(this.email);
        }
    }

    resetPassword() {
        if(this.validateResetPassword()) {
            this.authService.loginWithResetPassword(this.email, this.password1, this.resetToken);
        }
    }

    showRecoverPassword() {
        this.recover_password = true;
    }


    handleKeypress(event) {
        if (event.keyCode == 13) {
            if(this.resetToken != null)
                this.resetPassword();
            else if(this.recover_password && this.resetToken == null)
                this.recoverPassword();
            else 
                this.login();
            //event.preventDefault();
            return false;
             
        }
       
       return true;
    }

    validateLogin() {
        var pass = true;
        
        if (this.email == null || this.email.trim() == '') {
            this.userMessageService.setUserError("login", "Email is empty");
            pass = false;
        }

        if (this.password == null || this.password.trim() == '') {
            this.userMessageService.setUserError("login", "Password is empty");
            pass = false;
        }

        return pass;

    }

    validateRecoverPassword() {
        var pass = true;
        
        if (this.email == null || this.email.trim() == '') {
            this.userMessageService.setUserError("login", "Email is empty");
            pass = false;
        }

        return pass;

    }

    validateResetPassword() {
        var pass = true;
        
        if (this.email == null || this.email.trim() == '') {
            this.userMessageService.setUserError("login", "Email is empty");
            pass = false;
        }

        if(this.password1 == null || this.password1.trim() == '' || this.password2 == null || this.password2.trim() == '') {
            this.userMessageService.setUserError("login", "Password is empty");
            pass = false;
        }

        if(this.password1 != this.password2) {
            this.userMessageService.setUserError("login", "Passwords do not match");
            pass = false;
        }

        return pass;

    }

}
